import urlHostName from '../url/host-name';

const f = (): Record<string, string> => ({
    'adopt-origin': `https://${urlHostName()}`,
    dateTime: new Date().toUTCString(),
    timeOffset: new Date().getTimezoneOffset().toString(),
});

export default f;
